module.exports = __webpack_public_path__ + "b6e60ee038acf0ef9ce4d175b778eb72.MP3";